@use "styles/variables" as *;

.host {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1100;
}

.toast {
  position: absolute;
  top: 100px;
  right: 24px;
  display: flex;
  width: 300px;
  padding: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(58, 112, 191, 0.15);
  opacity: 0;
  transform: translateY(-8px);
  transition:
    opacity 200ms ease,
    transform 200ms ease;
  pointer-events: auto;
  overflow: hidden;
  cursor: default;
}

.visible {
  opacity: 1;
  transform: translateY(0);
}

.body {
  flex: 1;
  margin: 10px 20px;
  padding-right: 10px;
}

.title {
  margin: 0 0 2px;
  font-size: 12px;
  font-weight: bold;
  color: $mainTextColor;
}

.description {
  margin: 0;
  font-size: 10px;
  color: $mainTextColor;
}

.close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  border: none;
  border-left: 1px solid $borderColor;
  background: transparent;
  font-size: 12px;
  font-weight: bold;
  color: $infoColor;
  cursor: pointer;
  padding: 0;
}
